'use client';

import { useCallback, useState } from 'react';
import { useSearchQuery } from '@/hooks/useSearchQuery';

export function usePagination(pageLimit = 0, totalCount = 0, searchKey: string, perPageSearchKey?: string) {
  const [query, updateSearchQuery] = useSearchQuery();
  const [currentPage, setCurrentPage] = useState(Number(query.get(searchKey)) || 1);
  const [offset, setOffset] = useState(0);
  const [perPage, setPerPage] = useState(
    perPageSearchKey ? Number(query.get(perPageSearchKey)) || pageLimit : pageLimit
  );

  const effectivePageLimit = perPageSearchKey ? perPage : pageLimit;
  const totalPages = Math.ceil(totalCount / effectivePageLimit);
  const displayPaginationBar = totalCount > effectivePageLimit;

  const handleChangePage = useCallback(
    (page: number | string) => {
      const currentPage = Number(page);
      setCurrentPage(currentPage);
      const offset = (currentPage - 1) * effectivePageLimit;
      setOffset(offset);
      updateSearchQuery({
        [searchKey]: String(currentPage),
      });
    },
    [effectivePageLimit, updateSearchQuery, searchKey]
  );

  const handleChangePerPage = useCallback(
    (value: number) => {
      setPerPage(value);
      setCurrentPage(1);
      setOffset(0);
      updateSearchQuery({
        [searchKey]: '1',
        ...(perPageSearchKey ? { [perPageSearchKey]: String(value) } : {}),
      });
    },
    [updateSearchQuery, searchKey, perPageSearchKey]
  );

  return {
    totalPages,
    displayPaginationBar,
    handleChangePage,
    handleChangePerPage,
    currentPage,
    setCurrentPage,
    offset,
    perPage: effectivePageLimit,
  };
}
